<script setup lang="ts">
import type { AppConfig } from 'nuxt/schema'

const auth = useAuth()
const appConfig = useAppConfig()

const updateNavItems = (appConfig: AppConfig, user: any) => {
  if (!appConfig.tairo.collapse || !appConfig.tairo.collapse.navigation) {
    return
  }

  appConfig.tairo.collapse.navigation.items = appConfig.nav.filter((item) => {
    if (item.shouldRender) {
      return item.shouldRender(user)
    }

    return true
  })

  updateAppConfig(appConfig)
}

onBeforeMount(() => {
  updateNavItems(appConfig, auth.user)
})
</script>
<template>
  <TairoCollapseLayout>
    <slot />
  </TairoCollapseLayout>
</template>
